module.exports = __webpack_public_path__ + "static/media/sima kharoof.5060f73e.png";